import { Layout } from 'antd';
import PropTypes from 'prop-types';

function Header(props) {
  const { Header } = Layout;
  const { children } = props;

  return <Header>{children}</Header>;
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
};
export default Header;
